import Dropdown, { DropdownItem } from '@oncore/ui/Dropdown';
import { useSelector } from 'src/hooks';
import { getAppStateSelector } from 'src/store/selectors';

enum SIMPLEXITY_LINKS {
  KNOWLEDGE_BASE = 'https://support.oncoreflex.com',
  KNOWLEDGE_BASE_FREEDOM = 'https://support.oncoreflex.com/freedom',
  CONTACT = 'https://www.oncoreservices.com/contact'
}

const ChromeRightAlignedTopBarItems = () => {
  const {
    currentContext: { context }
  } = useSelector(getAppStateSelector());

  const handleKnowledgeBaseClick = () => {
    const knowledgeBaseUrl =
      context === 'user'
        ? SIMPLEXITY_LINKS.KNOWLEDGE_BASE_FREEDOM
        : SIMPLEXITY_LINKS.KNOWLEDGE_BASE;
    window.open(knowledgeBaseUrl, '_blank', 'noreferrer');
  };

  const handleContactUsClick = () => {
    window.open(SIMPLEXITY_LINKS.CONTACT, '_blank', 'noreferrer');
  };

  return (
    <Dropdown
      variant="icon"
      iconVariant="help-circle"
      iconButtonProps={{
        variant: 'text',
        size: '2xl',
        style: {
          padding: 0
        }
      }}
    >
      <DropdownItem text="Knowledge Base" onClick={handleKnowledgeBaseClick} />
      <DropdownItem text="Contact Us" onClick={handleContactUsClick} />
    </Dropdown>
  );
};

export default ChromeRightAlignedTopBarItems;
